var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaterings = function SvgCaterings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6b6b6b;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    strokeWidth: 0,
    d: "M.02,5.63c-.18-1.58,1.06-2.97,2.65-2.97h6.67c1.59,0,2.83,1.39,2.65,2.97l-.45,4c-.15,1.35-1.29,2.37-2.65,2.37H3.12c-1.36,0-2.5-1.02-2.65-2.37L.02,5.63ZM2.67,4c-.8,0-1.41.69-1.32,1.48l.45,4c.08.67.65,1.18,1.32,1.18h5.76c.68,0,1.25-.51,1.32-1.18l.45-4c.09-.79-.53-1.48-1.32-1.48H2.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    strokeWidth: 0,
    d: "M3.33,2.67c0-1.47,1.19-2.67,2.67-2.67s2.67,1.19,2.67,2.67v2c0,.37-.3.67-.67.67s-.67-.3-.67-.67v-2c0-.74-.6-1.33-1.33-1.33s-1.33.6-1.33,1.33v2c0,.37-.3.67-.67.67s-.67-.3-.67-.67v-2Z"
  })));
};
export default SvgCaterings;